import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-process-runner',
  templateUrl: './process-runner.component.html',
  styleUrls: ['./process-runner.component.css']
})
export class ProcessRunnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
